"use strict";

import { breakpointsMap } from "./_settings.js";
import nodeEach from "../helper/_node-each.function.js";

(function () {
  // initialize facts teaser slider
  const FACTS_TEASER_SLIDER_SELECTOR = ".js--facts-teaser-slider";
  const factsTeaserSliders = document.querySelectorAll(FACTS_TEASER_SLIDER_SELECTOR);

  if (0 < factsTeaserSliders.length) {
    import("../classes/Slider.js").then(({ default: Slider }) => {
      nodeEach(factsTeaserSliders, (slider) => {
        new Slider(slider, {
          breakpoints: {
            [breakpointsMap.sm]: {
              slidesPerView: 2.1,
              spaceBetween: 20,
            },
            [breakpointsMap.md]: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        }).init();
      });
    });
  }
})();
